"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.faChevronDown = void 0;
const faChevronDown = {
  prefix: 'fal',
  iconName: 'faChevronDown',
  icon: [448, 512, [], '', 'M4.251 181.1C7.392 177.7 11.69 175.1 16 175.1c3.891 0 7.781 1.406 10.86 4.25l197.1 181.1l197.1-181.1c6.5-6 16.64-5.625 22.61 .9062c6 6.5 5.594 16.59-.8906 22.59l-208 192c-6.156 5.688-15.56 5.688-21.72 0l-208-192C-1.343 197.7-1.749 187.6 4.251 181.1z']
};
exports.faChevronDown = faChevronDown;